var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5813 20.0531H20.0531C20.2886 20.0544 20.5221 20.0089 20.7399 19.9194C20.9577 19.8298 21.1556 19.698 21.3221 19.5314C21.4886 19.3649 21.6205 19.167 21.71 18.9492C21.7996 18.7314 21.845 18.498 21.8438 18.2625V4.8375H10.2094L9.31878 2.15625H2.15627V18.2625C2.15503 18.498 2.2005 18.7314 2.29005 18.9492C2.37959 19.167 2.51144 19.3649 2.67797 19.5314C2.84449 19.698 3.04238 19.8298 3.26019 19.9194C3.478 20.0089 3.7114 20.0544 3.9469 20.0531H8.41878",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41895 16.4719H15.5814V21.8437H8.41895V16.4719Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12C12.475 12 12.9305 12.1887 13.2663 12.5245C13.6021 12.8603 13.7907 13.3157 13.7907 13.7906V16.4719H10.2095V13.7906C10.2095 13.3157 10.3981 12.8603 10.7339 12.5245C11.0697 12.1887 11.5252 12 12.0001 12Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15625 8.41876H21.8438",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealm);
export default __webpack_public_path__ + "static/media/realm.41478131303f5aaf8490ac633172a83a.svg";
export { ForwardRef as ReactComponent };